var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Event, Prop, html, svg, CustomElement } from '@sick-davinci/ce-decorators';
import { style } from './DnDFileChooser.style';
/**
 * A `davinci-dnd-file-chooser` is used to select one or multiple files.
 * User can either drop files or open the file-chooser.
 *
 * @example
 * ```html
 * <davinci-dnd-file-chooser></davinci-dnd-file-chooser>
 * ```
 */

export let DnDFileChooser = (_dec = Component({
  tag: 'davinci-dnd-file-chooser',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop({
  reflectAsAttribute: false
}), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Event(), _dec13 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class DnDFileChooser extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "labelDrop", _descriptor, this);

    _initializerDefineProperty(this, "labelBrowse", _descriptor2, this);

    _initializerDefineProperty(this, "accept", _descriptor3, this);

    _initializerDefineProperty(this, "disabled", _descriptor4, this);

    _initializerDefineProperty(this, "change", _descriptor5, this);

    _defineProperty(this, "_files", null);

    _defineProperty(this, "dragOverEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      this.shadowRoot.querySelector('.dropArea').classList.add('selected');
    });

    _defineProperty(this, "dropEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      this._files = event.dataTransfer.files;
      this.change.emit(this._files);
      this.shadowRoot.querySelector('.dropArea').classList.remove('selected');
    });

    _defineProperty(this, "dragLeaveEvent", event => {
      event.preventDefault();
      event.stopPropagation();
      this.shadowRoot.querySelector('.dropArea').classList.remove('selected');
    });

    _defineProperty(this, "clickEvent", event => {
      event.preventDefault();
      event.stopPropagation();

      this._elementInput.click();
    });

    _defineProperty(this, "onFileSelect", event => {
      event.preventDefault();
      event.stopPropagation();
      this._files = event.currentTarget.files;
      this.change.emit(this._files); // Fix for selecting a file two times in a row, otherwise the change event won't be fired

      this._elementInput.value = '';
    });
  }

  /**
   * Gets the selected and dropped files.
   */
  get files() {
    return this._files;
  }
  /**
   * Emitted [Array<File>] if the user dropped or selected one or more files.
   */


  render() {
    return html`
    <div class="dropArea" for="file"
    @dragenter=${this.dragOverEvent}
    @dragover=${this.dragOverEvent}
    @drop=${this.dropEvent}
    @dragleave=${this.dragLeaveEvent}
    @click=${this.clickEvent}>
      <div class="container">
        ${svg`
          <svg class="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect class="border" x="0" y="0" width="100%" height="100%"/>
          </svg>`}
        <div class="description">
          ${svg`
            <svg class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
              <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/>
            </svg>`}
          <span class="text"><span class="labelDrop">${this.labelDrop}</span>
          <span class="labelBrowse">${this.labelBrowse}</span></span>
        </div>
      </div>
    </div>
    <input type="file" class="inputfile" multiple="true" accept="${this.accept}" @change="${this.onFileSelect}"/>
    `;
  }

  componentFirstRender() {
    this._elementInput = this.shadowRoot.querySelector('input');
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "labelDrop", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'Drop files to attach, or ';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "labelBrowse", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'browse';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "accept", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "files", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "files"), _class2.prototype), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
